import React from 'react';

const ScGrid = ({ columns, rows, onEdit, emptyMessage = 'No records found.' }) => {
  if (!rows || rows.length === 0) {
    return <p className="sc-empty">{emptyMessage}</p>;
  }
  return (
    <div className="sc-grid-wrap">
      <table className="sc-grid">
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.key}>{col.label}</th>
            ))}
            {onEdit && <th>Actions</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, idx) => (
            <tr key={row.id ?? row.key ?? idx}>
              {columns.map((col) => (
                <td key={col.key}>
                  {col.render ? col.render(row) : (row[col.key] ?? '—')}
                </td>
              ))}
              {onEdit && (
                <td>
                  <button type="button" className="sc-btn sc-btn-link" onClick={() => onEdit(row)}>Edit</button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ScGrid;
